import { formatDateTime } from "./format-date"

export type QuizPublishState = "scheduled" | "live" | "past-cutoff"

export interface QuizPublishStatusMeta {
  state: QuizPublishState
  label: string
  description: string
  color: "green" | "orange" | "gray"
}

interface PublishStatusInput {
  publishDate?: string | null
  cutoffDate?: string | null
  referenceDate?: Date
}

const isValidDate = (value: Date | null): value is Date =>
  Boolean(value && !Number.isNaN(value.getTime()))

export function getQuizPublishStatus({
  publishDate,
  cutoffDate,
  referenceDate = new Date(),
}: PublishStatusInput): QuizPublishStatusMeta {
  const publish = publishDate ? new Date(publishDate) : null
  const cutoff = cutoffDate ? new Date(cutoffDate) : null

  if (isValidDate(cutoff) && cutoff < referenceDate) {
    return {
      state: "past-cutoff",
      label: "Closed",
      description: `Cutoff passed ${formatDateTime(cutoff)}`,
      color: "gray",
    }
  }

  if (isValidDate(publish) && publish > referenceDate) {
    return {
      state: "scheduled",
      label: "Scheduled",
      description: `Publishes ${formatDateTime(publish)}`,
      color: "orange",
    }
  }

  return {
    state: "live",
    label: "Live",
    description: isValidDate(publish)
      ? `Published ${formatDateTime(publish)}`
      : "Visible immediately",
    color: "green",
  }
}
